@if (wordCloudData.length === 0 && !isLoading) {
  <div class="no-graphic">
    <img src="assets/imgs/undraw/undraw_no_data.svg" alt="Nessuna Wordcloud" />
    <span>Nessuna Wordcloud disponibile</span>
  </div>
}
@if (wordCloudData.length > 0 && !isLoading) {
  <div class="wordcloud-container">
    <canvas #canvasRef></canvas>
  </div>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}
